import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FunctionsService } from 'src/app/services/functions.service';
import { HttpService } from '../../services/http.service';
import { AreaActivities } from '../../models/areaActivities.model';
import { Jobs } from '../../models/jobs.model';
import { Professions } from 'src/app/models/professions.model';
import { Companies } from 'src/app/models/companies.model';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { JobsTrainings } from 'src/app/models/jobsTrainings.models';
import { Trainings } from 'src/app/models/trainings.model';
import { Languages } from '../../models/languages.model';
import { JobsLanguages } from '../../models/jobsLanguages.models';
import { Skills } from '../../models/skills.model';
import { JobsSkills } from '../../models/jobsSkills.models';

@Component({
  selector: 'app-admin-post-job-offer',
  templateUrl: './admin-post-job-offer.component.html',
  styleUrls: ['./admin-post-job-offer.component.scss']
})
export class AdminPostJobOfferComponent implements OnInit {
  jobForm: FormGroup = new FormGroup({});
  jobIsLoading: boolean = false;
  reference: string = '';
  areaActivityList: AreaActivities[] = [];
  professionList: Professions[] = [];
  companyList: Companies[] = [];
  countryData: any;
  countryList: any[] = [];
  cityList: any[] = [];
  jobEditing: Jobs = new Jobs({});
  jobTrainingForm: FormGroup = new FormGroup({});
  jobTrainingIsLoading: boolean = false;
  jobTrainingList: JobsTrainings[] = [];
  trainingList: Trainings[] = [];
  jobLanguageForm: FormGroup = new FormGroup({});
  jobLanguageIsLoading: boolean = false;
  jobLanguageList: JobsLanguages[] = [];
  languageList: Languages[] = [];
  jobSkillForm: FormGroup = new FormGroup({});
  jobSkillIsLoading: boolean = false;
  jobSkillList: JobsSkills[] = [];
  skillList: Skills[] = [];
  jobStatus: string = '';
  currentAdmin: any;
  jobDescribeValue: any;
  jobDescribeFile: any;
  jobDescribe: any;

  constructor(private formBuilder: FormBuilder, public functionsService: FunctionsService, private httpService: HttpService, private datepipe: DatePipe) {
    this.getJobEditing();
    this.reference = (this.jobEditing.getId() != undefined) ? this.jobEditing.getReference() : '';
    this.currentAdmin = functionsService.checkAdminIsConnected();
  }

  ngOnInit(): void {
    this.companyList = this.functionsService.getCompaniesList();
    console.log(this.functionsService.getCompaniesList());
    this.initJobForm();
    this.initJobTrainingForm();
    this.initJobLanguageForm();
    this.initJobSkillForm();
  }

  getJobEditing() {
    if (localStorage.getItem('jobEditing') != undefined) {
      const dataString: any = localStorage.getItem('jobEditing');
      this.jobEditing = new Jobs(JSON.parse(dataString));
      this.jobStatus = this.jobEditing.getStatus();
    }
  }

  initJobForm() {
    this.areaActivityList = this.functionsService.getAreaActivitiesList();
    this.professionList = this.functionsService.getProfessionsList();

    this.loadCountries();

    var splitDate = (this.jobEditing.getId() != undefined) ? this.jobEditing.getExpirationDate().toString().split('-') : null;

    const expiration_datetime = (splitDate != null) ? new Date(splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2]) : new Date();
    let expiration_date;
    try {
      expiration_date = this.datepipe.transform(expiration_datetime, 'yyyy-MM-dd');
    } catch (error) {
    }

    this.jobDescribeValue = this.jobEditing.getJobDescribeFile();
    this.jobDescribe = (this.jobEditing.getJobDescribeFile() != null) ? this.jobEditing.getJobDescribeFile() : '';

    this.jobForm = this.formBuilder.group({
      area_activity_id: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getAreaActivity()['id'] : '', Validators.required],
      profession_id: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getProfession()['id'] : '', Validators.required],
      libelle: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getLibelle() : '', Validators.required],
      type_job: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getTypeJob() : '', Validators.required],
      job_level: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getJobLevel() : '', Validators.required],
      years_of_experience: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getYearOfExperience() : ''],
      years_exp_rating: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getYearsExpRating() : ''],
      min_age: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getMinAge() : ''],
      max_age: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getMaxAge() : ''],
      age_rating: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getAgeRating() : ''],
      country: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getCountry() : 'Benin', Validators.required],
      city: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getCity() : 'Cotonou', Validators.required],
      expiration_date: [expiration_date, Validators.required],
      description: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getDescription() : '', Validators.required],
      company_id: [(this.jobEditing.getId() != undefined) ? this.jobEditing.getCompany()['id'] : '', Validators.required],
    });
  }

  onSubmitJobForm() {
    let formValue: any = this.jobForm.value;
    formValue['job_describe'] = this.jobDescribeFile;
    this.jobIsLoading = true;
    if (this.jobEditing.getId() == undefined) {
      this.httpService.saveJob(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let data = response.data;
            localStorage.setItem('jobEditing', JSON.stringify(data));
            this.jobIsLoading = false;
            this.initJobForm();
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Emploi sauvegardé avec succès.',
            }).then(() => {
              window.location.reload();
            });
          }
        },
        (error) => {
          console.log(error);
          this.jobIsLoading = false;
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      );
    } else {
      formValue['job_id'] = this.jobEditing.getId();
      formValue['token'] = this.currentAdmin['token'];

      this.httpService.updateJob(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let data = response.data;
            localStorage.setItem('jobEditing', JSON.stringify(data));
            this.jobIsLoading = false;
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Emploi mise à jour avec succès.',
            }).then(() => {
              window.location.reload();
            });
          }
        },
        (error) => {
          this.jobIsLoading = false;
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      );
    }
  }

  initJobTrainingForm() {
    this.trainingList = this.functionsService.getTrainingsList();
    this.jobTrainingList = this.jobEditing.getJobsTrainings();
    this.jobTrainingForm = this.formBuilder.group({
      training_id: ['', Validators.required],
      level_of_study: ['', Validators.required],
      rating: ['', Validators.required],
      // certifcat_rating: ['', Validators.required]
    });
  }

  onSubmitJobTrainingForm() {
    let formValue: any = this.jobTrainingForm.value;
    this.jobTrainingIsLoading = true;

    if (this.jobEditing.getId() != undefined) {
      formValue['job_id'] = this.jobEditing.getId();
      this.httpService.addJobTraining(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let data = response.data;
            localStorage.setItem('jobEditing', JSON.stringify(data));
            this.jobEditing = new Jobs(data);
            this.jobTrainingList = this.jobEditing.getJobsTrainings();
            this.jobTrainingIsLoading = false;
            this.initJobTrainingForm();
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Formation sauvegardée avec succès.',
            })
          }
        },
        (error) => {
          console.log(error);
          this.jobTrainingIsLoading = false;
          if (error.error.message == 'JOBS_TRAININGS_ALREADY_EXIST') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Cette formation a déjà été ajoutée.',
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        }
      );
    } else {
      this.jobTrainingIsLoading = false;
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez enregistrer d\'abord l\'emploi.',
      })
    }
  }

  removeJobTraining(job_training_id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer cette formation ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeJobTraining(job_training_id).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('jobEditing', JSON.stringify(data));
              this.jobEditing = new Jobs(data);
              this.jobTrainingList = this.jobEditing.getJobsTrainings();
              this.jobTrainingIsLoading = false;
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Formation supprimée.',
              });
              this.initJobTrainingForm();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  initJobLanguageForm() {
    this.languageList = this.functionsService.getLanguagesList();
    this.jobLanguageList = this.jobEditing.getJobsLanguages();

    this.jobLanguageForm = this.formBuilder.group({
      language_id: ['', Validators.required],
      level: ['', Validators.required],
      rating: ['', Validators.required]
    });
  }

  onSubmitJobLanguageForm() {
    let formValue: any = this.jobLanguageForm.value;
    this.jobLanguageIsLoading = true;

    if (this.jobEditing.getId() != undefined) {
      formValue['job_id'] = this.jobEditing.getId();
      this.httpService.addJobLanguage(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let data = response.data;
            localStorage.setItem('jobEditing', JSON.stringify(data));
            this.jobEditing = new Jobs(data);
            this.jobLanguageList = this.jobEditing.getJobsLanguages();
            this.jobLanguageIsLoading = false;
            this.initJobLanguageForm();
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Langue sauvegardée avec succès.',
            })
          }
        },
        (error) => {
          this.jobLanguageIsLoading = false;
          if (error.error.message == 'JOBS_LANGUAGES_ALREADY_EXIST') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Cette langue a déjà été ajoutée.',
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        }
      );
    } else {
      this.jobLanguageIsLoading = false;
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez enregistrer d\'abord l\'emploi.',
      })
    }
  }

  removeJobLanguage(job_language_id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer cette langue ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeJobLanguage(job_language_id).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('jobEditing', JSON.stringify(data));
              this.jobEditing = new Jobs(data);
              this.jobLanguageList = this.jobEditing.getJobsLanguages();
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Langue supprimée.',
              });
              this.initJobLanguageForm();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  initJobSkillForm() {
    this.skillList = this.functionsService.getSkillsList();
    this.jobSkillList = this.jobEditing.getJobsSkills();

    this.jobSkillForm = this.formBuilder.group({
      skill_id: ['', Validators.required],
      level: ['', Validators.required],
      rating: ['', Validators.required]
    });
  }

  onSubmitJobSkillForm() {
    let formValue: any = this.jobSkillForm.value;
    this.jobSkillIsLoading = true;

    if (this.jobEditing.getId() != undefined) {
      formValue['job_id'] = this.jobEditing.getId();
      this.httpService.addJobSkill(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let data = response.data;
            localStorage.setItem('jobEditing', JSON.stringify(data));
            this.jobEditing = new Jobs(data);
            this.jobSkillList = this.jobEditing.getJobsSkills();
            this.jobSkillIsLoading = false;
            this.initJobSkillForm();
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Logiciel sauvegardé avec succès.',
            })
          }
        },
        (error) => {
          this.jobSkillIsLoading = false;
          if (error.error.message == 'JOBS_SKILLS_ALREADY_EXIST') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Ce logiciel a déjà été ajouté.',
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        }
      );
    } else {
      this.jobSkillIsLoading = false;
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez enregistrer d\'abord l\'emploi.',
      })
    }
  }

  removeJobSkill(job_skill_id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer ce logiciel ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeJobSkill(job_skill_id).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('jobEditing', JSON.stringify(data));
              this.jobEditing = new Jobs(data);
              this.jobSkillList = this.jobEditing.getJobsSkills();
              this.initJobSkillForm();
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Logiciel supprimé.',
              });
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  publishJob() {
    if (this.jobEditing.getJobsTrainings().length == 0) {
      Swal.fire({
        icon: 'error',
        title: 'Oups...',
        text: 'Vous devez associer au moins une formation à cette offre.',
      })
    } else {
      Swal.fire({
        title: 'Souhaitez vous publier cette offre d\'emploi ?',
        showDenyButton: true,
        confirmButtonText: 'Oui',
        denyButtonText: `Non`,
        confirmButtonColor: '#28a745',
        denyButtonColor: 'dc3545'
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire('Veuillez patientez...');
          this.httpService.updateJobStatus(this.jobEditing.getId(), 'Validé').subscribe(
            (response: any) => {
              if (response.status == "success") {
                let data = response.data;
                localStorage.setItem('jobEditing', JSON.stringify(data));
                this.getJobEditing();
                this.jobIsLoading = false;
                Swal.fire({
                  icon: 'success',
                  title: 'Excellent !',
                  text: 'Cet emploi sera à présent visible par les candidats.',
                })
              }
            },
            (error) => {
              this.jobIsLoading = false;
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Vérifier votre connexion puis réessayé.',
              })
            }
          );
        }
      })
    }
  }

  async addNewSkill() {
    const { value: libelle } = await Swal.fire({
      title: 'Nouveau logiciel',
      input: 'text',
      inputLabel: 'Logiciel',
      inputPlaceholder: 'Entrer le logiciel'
    })

    if (libelle) {
      Swal.fire({
        title: 'Souhaitez continuer cette opération ?',
        showDenyButton: true,
        confirmButtonText: 'Oui',
        denyButtonText: `Non`,
        confirmButtonColor: '#28a745',
        denyButtonColor: 'dc3545'
      }).then((result) => {
        if (result.isConfirmed) {
          // Save libelle in DBB
          Swal.fire('Veuillez patientez...');
          this.httpService.addSkill(libelle, this.currentAdmin.token).subscribe(
            (response: any) => {
              if (response.status == "success") {
                let data = response.data;
                localStorage.setItem('skills', JSON.stringify(data));
                this.skillList = this.functionsService.getSkillsList();
                Swal.fire({
                  icon: 'success',
                  title: 'Excellent !',
                  text: 'Logiciel ajouté.',
                })
              }
            },
            (error) => {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Vérifier votre connexion puis réessayée.',
              })
            }
          );
        }
      })
    }
  }

  async addNewLanguage() {
    const { value: libelle } = await Swal.fire({
      title: 'Nouvelle langue',
      input: 'text',
      inputLabel: 'Langue',
      inputPlaceholder: 'Entrer la langue'
    })

    if (libelle) {
      Swal.fire({
        title: 'Souhaitez continuer cette opération ?',
        showDenyButton: true,
        confirmButtonText: 'Oui',
        denyButtonText: `Non`,
        confirmButtonColor: '#28a745',
        denyButtonColor: 'dc3545'
      }).then((result) => {
        if (result.isConfirmed) {
          // Save libelle in DBB
          Swal.fire('Veuillez patientez...');
          this.httpService.addLanguage(libelle, this.currentAdmin.token).subscribe(
            (response: any) => {
              if (response.status == "success") {
                let data = response.data;
                localStorage.setItem('languages', JSON.stringify(data));
                this.languageList = this.functionsService.getLanguagesList();
                Swal.fire({
                  icon: 'success',
                  title: 'Excellent !',
                  text: 'Langue ajoutée.',
                })
              }
            },
            (error) => {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Vérifier votre connexion puis réessayée.',
              })
            }
          );
        }
      })
    }
  }

  async addNewTraining() {
    const { value: libelle } = await Swal.fire({
      title: 'Nouvelle formation',
      input: 'text',
      inputLabel: 'Formation',
      inputPlaceholder: 'Entrer la formation'
    })

    if (libelle) {
      Swal.fire({
        title: 'Souhaitez continuer cette opération ?',
        showDenyButton: true,
        confirmButtonText: 'Oui',
        denyButtonText: `Non`,
        confirmButtonColor: '#28a745',
        denyButtonColor: 'dc3545'
      }).then((result) => {
        if (result.isConfirmed) {
          // Save libelle in DBB
          Swal.fire('Veuillez patientez...');
          this.httpService.addTraining(libelle, this.currentAdmin.token).subscribe(
            (response: any) => {
              if (response.status == "success") {
                let data = response.data;
                localStorage.setItem('trainings', JSON.stringify(data));
                this.trainingList = this.functionsService.getTrainingsList();
                Swal.fire({
                  icon: 'success',
                  title: 'Excellent !',
                  text: 'Formation ajoutée.',
                })
              }
            },
            (error) => {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Vérifier votre connexion puis réessayée.',
              })
            }
          );
        }
      })
    }
  }



  async addNewAreaActivity() {
    const { value: libelle } = await Swal.fire({
      title: 'Nouveau secteur d\'activité',
      input: 'text',
      inputLabel: 'Secteur d\'activité',
      inputPlaceholder: 'Entrer le secteur d\'activité'
    })

    if (libelle) {
      Swal.fire({
        title: 'Souhaitez continuer cette opération ?',
        showDenyButton: true,
        confirmButtonText: 'Oui',
        denyButtonText: `Non`,
        confirmButtonColor: '#28a745',
        denyButtonColor: 'dc3545'
      }).then((result) => {
        if (result.isConfirmed) {
          // Save libelle in DBB
          Swal.fire('Veuillez patientez...');
          this.httpService.addAreaActivity(libelle, this.currentAdmin.token).subscribe(
            (response: any) => {
              if (response.status == "success") {
                let data = response.data;
                localStorage.setItem('areaActivities', JSON.stringify(data));
                this.areaActivityList = this.functionsService.getAreaActivitiesList();
                Swal.fire({
                  icon: 'success',
                  title: 'Excellent !',
                  text: 'Secteur d\'activité ajouté.',
                })
              }
            },
            (error) => {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Vérifier votre connexion puis réessayée.',
              })
            }
          );
        }
      })
    }
  }

  async addNewProfession() {
    const { value: libelle } = await Swal.fire({
      title: 'Nouvelle profession',
      input: 'text',
      inputLabel: 'Profession',
      inputPlaceholder: 'Entrer la profession'
    })

    if (libelle) {
      Swal.fire({
        title: 'Souhaitez continuer cette opération ?',
        showDenyButton: true,
        confirmButtonText: 'Oui',
        denyButtonText: `Non`,
        confirmButtonColor: '#28a745',
        denyButtonColor: 'dc3545'
      }).then((result) => {
        if (result.isConfirmed) {
          // Save libelle in DBB
          Swal.fire('Veuillez patientez...');
          this.httpService.addProfession(libelle, this.currentAdmin.token).subscribe(
            (response: any) => {
              if (response.status == "success") {
                let data = response.data;
                localStorage.setItem('professions', JSON.stringify(data));
                this.professionList = this.functionsService.getProfessionsList();
                Swal.fire({
                  icon: 'success',
                  title: 'Excellent !',
                  text: 'Profession ajoutée.',
                })
              }
            },
            (error) => {
              console.log(error);
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Vérifier votre connexion puis réessayée.',
              })
            }
          );
        }
      })
    }
  }

  loadCountries() {
    this.httpService.getCountries().subscribe(data => {
      this.countryData = data;
      const countries: any = data;
      let countryList: any[] = [];
      countries.find((item: { country: any; }) => {
        const country = item.country
        if (!countryList.includes(country)) {
          countryList.push(country)
        }
      });

      this.countryList = countryList.sort();

      this.cityList = this.functionsService.findCitiesOfCountry('Benin', this.countryData);
    })
  }

  onChangeCountry(country: string) {
    this.cityList = this.functionsService.findCitiesOfCountry(country, this.countryData);
  }

  async chooseNewJobDescribeFile() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner le fichier',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Fichier selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.jobDescribeFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }

    }
  }
}
